module.exports = __webpack_public_path__ + "media/images/proof_links/colored/beru-0817f5854a457bb4011b267828dc7ca6.svg";